import React from 'react'
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
import getStrings from 'getStrings'
import getLanguage from 'getLanguage'
import AppContext from 'core/appContext'
import { withRouter } from 'react-router-dom'
import { loginWithCustomID } from '../../Playfab'
import getWidgetsOrigin from "../getWidgetsOrigin";
import { sha256 } from "js-sha256";


class WidgetsTeacherSignUpForm extends React.Component {
    constructor(props) {
        super(props)

        const origin = getWidgetsOrigin()

        let parentOrigin

        if (origin === 'educators')
            parentOrigin = 'https://www.educators.ululab.com/registration'

        this.state = {
            parentOrigin: parentOrigin
        }
    }

    getBaseEndpoint = () => {
        switch (process.env['REACT_APP_ENV']) {
            case "prod": return 'https://hntwyyngq8.execute-api.us-east-1.amazonaws.com/prod'
            case "dev": return 'https://twq3jitb16.execute-api.us-east-1.amazonaws.com/dev'
            case 'danny': return 'https://d3patqtvf3.execute-api.us-east-1.amazonaws.com/danny'
            case 'gabriel': return 'https://i8316be193.execute-api.us-east-1.amazonaws.com/gabriel'
            default: return 'https://d3patqtvf3.execute-api.us-east-1.amazonaws.com/danny'
        }
    }

    getFormData(form) {
        const formData = new FormData(document.forms[form])

        const params = new URLSearchParams()

        formData.forEach((value, key) => params.append(key, value))

        return params
    }

    blockUI = (shouldBlock) => {
        this.context.setBlockUI(shouldBlock)
    }

    displayError = (errorCode) => {
        console.log(errorCode)
        if (!errorCode || Object.keys(errorCode).length === 0) {
            console.error('WidgetsTeacherSignUpForm.displayError: generic: ', errorCode)
            return alert(getStrings()['GENERIC_ERROR'])
        }

        console.error(`WidgetsTeacherSignUpForm.displayError: ${errorCode}`)
        alert(getStrings()[`TEACHER_SIGNUP_${errorCode}`])
    }

    createTeacherClicked = async (event) => {
        event.preventDefault()

        if (!this.state.parentOrigin) {
            alert('Invalid parent origin!')
            return
        }

        // Check that all fields marked as required are present.
        if (!document.forms[event.target.dataset.form].reportValidity())
            return

        this.blockUI(true)
        
        const teacherAuthID = uuidv4()

        let teacherPlayfabID
        try {
            const playfabAPIResponse = await loginWithCustomID(teacherAuthID)

            teacherPlayfabID = playfabAPIResponse.data.data.PlayFabId
        } catch (error) {
            console.error(`Error when creating a playfab account for teacherAuthID: ${teacherAuthID}.`)
            console.error(error)
            return
        }

        const data = this.getFormData(event.target.dataset.form)
        data.append('teacherPlayfabID', teacherPlayfabID)
        data.append('teacherAuthID', teacherAuthID)

        const hashedEmail = sha256(data.get('email').toLowerCase())

        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }

        // Send to teacher account creation
        axios.post(`${this.getBaseEndpoint()}/teachers?lang=${getLanguage()}`, data, config)
            .then((response) => {
                this.blockUI(false)

                if (!response.data.success) {

                    // This is a workaround to preserve the current displayError's logic.
                    if (response.data.error === "TEACHER_ALREADY_EXISTS")
                        response.data.error = "TEACHER_ALREADY_EXISTS_WIDGET"

                    console.log(`error code: ${response.data.error}`)
                    console.log(`response data: ${JSON.stringify(response.data)}`)
                    this.displayError(response.data.error)
                } else {
                    console.log(`success: ${JSON.stringify(response.data)}`)

                    const message = {
                        type: "AUTH_SUCCESS",
                        classroomCode: response.data.classroomCode,
                        classroomID: response.data.classroomID
                    }

                    window.fbq('track', 'CompleteRegistration', {
                        content_name: 'Widget Teacher Sign Up',
                        status: 'Success',
                        em: hashedEmail
                    })

                    window.fbq('trackCustom', 'CompleteTeacherRegistrationCustom', {
                        content_name: 'Widget Teacher Sign Up',
                        status: 'Success',
                        em: hashedEmail
                    })

                    console.log(`Sending message back to ${this.state.parentOrigin}. message: `, JSON.stringify(message))
                    window.parent.postMessage(
                        message,
                        this.state.parentOrigin
                    )
                }
            })
            .catch((err) => {
                console.error(`Network error: ${err.code}: ${err.message}`)
                console.error(err)
            })
    }

    render() {
        return (
            <>
                {this.renderFormCreateTeacher()}
            </>
        )
    }

    renderFormCreateTeacher() {
        const strings = getStrings()

        return (
            <form
                id="formTeacherSignUp"
                className='form-container form-box'
                style={{ fontFamily: 'Comfortaa, sans-serif' }}
            >
                <p className='tiny-text margin-bottom-2'>* {strings.TEACHER_LOUNGE_FORM_REQUIRED_FIELDS}</p>

                <input
                    name="email"
                    type="email"
                    className='margin-bottom-2'
                    placeholder={strings.TEACHER_LOUNGE_FORM_EMAIL + '*'}
                    required
                />
                <input
                    name="name"
                    type="text"
                    className='margin-bottom-2'
                    placeholder={strings.TEACHER_LOUNGE_FORM_NAME + '*'}
                    required
                />
                <input
                    name="numStudents"
                    type="number"
                    className='margin-bottom-2'
                    placeholder={strings.TEACHER_LOUNGE_FORM_NUM_STUDENTS + '*'}
                    min="1"
                    max="35"
                    //defaultValue="23"
                    required
                />
                <input
                    name="schoolName"
                    type="text"
                    className='margin-bottom-2'
                    placeholder={strings.TEACHER_LOUNGE_FORM_SCHOOL_NAME}
                />

                <select
                    name="ageGroup"
                    className='margin-bottom-2'
                    defaultValue={''}
                    style={{ color: 'grey' }}
                    onChange={e => {
                        e.target.style.color = e.target.value === "" ? "grey" : "black";
                    }}
                >
                    <option value="" disabled hidden style={{ color: 'grey' }}>
                        {strings.TEACHER_LOUNGE_FORM_AGE_GROUP}
                    </option>
                    <option value="4-5">4-5</option>
                    <option value="5-6">5-6</option>
                    <option value="6-7">6-7</option>
                    <option value="7-8">7-8</option>
                    <option value="8-9">8-9</option>
                    <option value="9-10">9-10</option>
                    <option value="11+">11+</option>
                </select>

                <p className='margin-top-2 margin-bottom-1'>
                    {strings.TEACHER_LOUNGE_FORM_REFERRAL_EMAIL_PROMPT}
                </p>
                <input
                    name="referralEmail"
                    type="text"
                    className='margin-bottom-1'
                    placeholder={strings.TEACHER_LOUNGE_FORM_REFERRAL_EMAIL}
                />

                <div
                    className='padding-left-2 padding-right-2 margin-top-2 margin-bottom-2 small-text text-center'
                    dangerouslySetInnerHTML={{ __html: strings.TEACHER_LOUNGE_FORM_EXPLANATION_1_WIDGET }}
                />

                <button
                    data-form='formTeacherSignUp'
                    onClick={this.createTeacherClicked.bind(this)}
                    className="form-button"
                    style={{
                        backgroundColor: '#f09939',
                        fontFamily: "'Fredoka One', sans-serif",
                        fontSize: '1.5em',
                        letterSpacing: '0.04em'
                    }}
                >
                    {strings.TEACHER_LOUNGE_FORM_CREATE_BUTTON}
                </button>
            </form>
        )
    }
}

WidgetsTeacherSignUpForm.contextType = AppContext

export default withRouter(WidgetsTeacherSignUpForm)